module.exports = __webpack_public_path__ + "static/media/boy-22.ac3eb4f7.svg";